<template>
  <div>
    <van-search readonly placeholder="切换公司" @click="doCompShow" />

    <van-popup
      v-model:show="compShow"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <template>
        <div style="background: #f2f2f2;">
          <van-search
            v-model="searchCompany"
            show-action
            placeholder="请输入公司名称查询"
            overlayClass="overlay"
          >
            <template #action>
              <!-- <div class="flex">
              <div @click="doSearchComp">搜索</div>
              <div style="margin-left: 0.5rem;" @click="doCancelChange">取消</div>
            </div> -->
              <van-button type="primary" size="small" @click="doSearchComp"
                >搜索</van-button
              >
              <van-button
                type="default"
                size="small"
                @click="doCancelChange"
                style="margin-left: 0.3rem;"
                >取消
              </van-button>
            </template>
          </van-search>
          <van-cell-group>
            <van-cell
              is-link
              v-for="(item, index) in compList"
              :key="index"
              @click="doCompanyChange(item, $event)"
            >
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <div class="text-left">
                  <span class="iconfont iconqiye"></span>
                  <span class="custom-title" style="margin-left: 0.2rem;">{{
                    item.CompFullName
                  }}</span>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "company-change",
  data() {
    return {
      compShow: false,
      compList: [],
      searchCompany: "",
    };
  },
  methods: {
    /**
     * 展示公司选择弹出层
     */
    doCompShow() {
      this.compShow = true;
    },
    /**
     * 查询公司
     */
    doSearchComp() {
      if (!this.searchCompany) {
        this.$notify({
          message: "请输入公司名称查询",
          duration: 1000,
        });
        return;
      }
      this.$http
        .post(this.$api.getCompInfo, {
          query: this.searchCompany,
        })
        .then((res) => {
          console.log("getCompInfo", res);
          this.compList = res.data;
        });
    },
    /**
     * 取消选择公司
     */
    doCancelChange() {
      this.compShow = false;
    },
    /**
     * 切换公司
     */
    doCompanyChange(item) {
      let CompInfo = {
        CompGID: item.GID,
        CompName: item.CompFullName,
      };
      this.$store.commit("newCompInfo", CompInfo);

      // 重新设置渠道参数
      let params = {
        IsQueryCompAgent: true,
        IsEnabled: true,
        AgentTypeID: 1, // 自营
      };
      this.$http
        .post(this.$api.getAgentChannel, this.$qs.stringify(params))
        .then((res) => {
          if (res.success && res.data.length > 0) {
            let params = JSON.parse(window.localStorage.getItem("adminParams"));
            let index = params.findIndex(
              (p) => p.ParamCode == "WindowSaleAgentAppID"
            );
            if (index > -1) {
              params[index].ParamValue = res.data[0].AgentAppID;
            }
            window.localStorage.setItem("adminParams", JSON.stringify(params));
          }
        });
      this.compShow = false;
    },
  },
};
</script>

<style scoped lang="less"></style>
